import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
const DesktopProductsHeader = t0 => {
  const $ = _c(2);
  const {
    children
  } = t0;
  let t1;
  if ($[0] !== children) {
    t1 = <div className="items-center bg-white flex h-[53px] p-0 sticky top-[55px] z-[11] max-[1023px]:hidden">{children}</div>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
DesktopProductsHeader.propTypes = {
  children: PropTypes.node
};
export default DesktopProductsHeader;